export default __webpack_public_path__ + "static/media/item2.e5267db5.png";